import styled, { css } from 'styled-components';

const FlexRow = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    flex: 1;
    // gap: 16px;
    // width: 100%;
    // background-color: green;
    margin: ${theme.margins.default};
  `
);

export { FlexRow };
